import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SavedSearch} from 'search/saved-searches/SavedSearchUtil';
import {FONT_PROXIMA_12, LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import {BLUE_DARKER, GRAY, GRAY_DARKER, NEAR_BLACK} from 'ui-library/Colors';
import FooterOption from 'ui-library/menus/FooterOption';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, OptionData, OptionValue} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import {readableTime} from 'util/DateUtil';

interface SavedSearchesDropdownMenuProps {
  optionDatas: Array<OptionData>;
  onSelect: (value: OptionValue) => void;
  selectedValue?: OptionValue;
  openSavedSearchModal: () => void;
}

export function SavedSearchesDropdownMenu(props: SavedSearchesDropdownMenuProps): JSX.Element {
  // TODO(BNCH-50462): Change content of menu to owner of search and last time accessed instead of modified at and hardcode
  // TODO(BNCH-50465): Add star to content of menu

  return (
    <Menu width={Menu.WIDTHS.XXLARGE} height={Menu.HEIGHTS.XLARGE} className={css(styles.menu)}>
      {props.optionDatas.map((optionData, index) => (
        <Option
          className={optionData.className}
          isSelected={props.selectedValue === optionData.value}
          isDisabled={optionData.disabled}
          onSelect={props.onSelect}
          key={index}
          value={optionData.value}
          hasBorder={true}
          dataTestAttrs={optionData.dataTestAttrs}
        >
          <div className={css(styles.nameRow, optionData.disabled && styles.disabled)}>{optionData.name}</div>
          <div className={css(styles.metadataRow, optionData.disabled && styles.disabled)}>
            {getMetadataText(optionData.value, optionData.disabled)}
          </div>
        </Option>
      ))}
      <FooterOption
        onSelect={props.openSavedSearchModal}
        hasBorder={true}
        heightOverride={MenuHeight.MEDIUM}
        dataTestAttrs={{component: 'SavedSearchCard', element: 'viewAll'}}
      >
        <div className={css(styles.footerText)}>View all</div>
      </FooterOption>
    </Menu>
  );
}

function getMetadataText(savedSearch: SavedSearch, disabled: boolean | undefined): string {
  if (savedSearch) {
    if (!disabled) {
      return `${readableTime(savedSearch.modifiedAt, {showTime: false})} by ${savedSearch.ownerJson.name}`;
    } else {
      return 'You lack permissions to run this search.';
    }
  } else {
    return '';
  }
}

const styles = StyleSheet.create({
  metadataRow: {
    ...FONT_PROXIMA_12,
    inline: 'flex',
    color: GRAY_DARKER,
    alignSelf: 'stretch',
  },
  nameRow: {
    ...LEGACY_FONT_PROXIMA_TITLE,
    color: NEAR_BLACK,
  },
  menu: {
    borderRadius: '8px',
    boxShadow: `2px 0px 8px ${GRAY}`,
  },
  footerText: {
    color: BLUE_DARKER,
    ...LEGACY_FONT_PROXIMA_TITLE,
    marginRight: 10,
  },
  disabled: {
    opacity: 0.5,
  },
});
